import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_MANGROVE_LOCATION_DATA = "paginationMangroveLocationData";
export const LIST_MANGROVE_LOCATION_DATA = "listMangroveLocationData";
export const GET_MANGROVE_LOCATION_DATA = "getMangroveLocationData";
export const POST_MANGROVE_LOCATION_DATA = "postMangroveLocationData";
export const PUT_MANGROVE_LOCATION_DATA = "putMangroveLocationData";
export const PUT_MANGROVE_LOCATION_STATUS_DATA = "putMangroveLocationStatusData";
export const DELETE_MANGROVE_LOCATION_DATA = "deleteMangroveLocationData";
// mutation types
export const SET_STATE_PRAM_M_LOCATION = "setStarePramMLocation";
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";



export default {
  state: {
    path: "mangrove_location",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: "",
      data_pram:''
    }
  },
  getters: {},
  actions: {
    [PAGINATION_MANGROVE_LOCATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_MANGROVE_LOCATION_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_MANGROVE_LOCATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [POST_MANGROVE_LOCATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [PUT_MANGROVE_LOCATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [PUT_MANGROVE_LOCATION_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_MANGROVE_LOCATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_STATE_PRAM_M_LOCATION](state, payload) {
      state.data_pram = payload;
    },
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
